<ng-container *transloco="let t">
  <img
    class="logo"
    src="/assets/images/lifespeak_brand_logo.svg"
    alt="LifeSpeak"
    data-test-id="register-invite-code.logo"
  />

  @if (showMoreInfo()) {
    <app-login-more-info
      [clients]="clients"
      [inviteCode]="inviteCode"
    ></app-login-more-info>
  } @else {
  <div class="mt-12">
    <a tabindex="0" class="back-link flex items-center no-underline" (click)="onBack()" data-test-id="register-invite-code.back-button">
      <img
        class="back-icon"
        src="/assets/icons/left.svg"
        alt="Back"
      />
      <img
        class="back-icon-hover"
        src="/assets/icons/left-hover.svg"
        alt="Back"
      />
      <label class="ml-1.5 mb-1 text-ls_bright_blue no-underline cursor-pointer">{{ t('register.backToLogin') }}</label>
    </a>
  </div>

  <div class="pt-8">
    <h1 class="heading-t5" data-test-id="register-invite-code.title">{{ t('register.enterCode') }}</h1>
  </div>

  <form (submit)="onSubmit($event)" class="mt-4" data-test-id="register-invite-code.form">
    <div class="pt-5">
      @if (inviteCodeControl.touched && inviteCodeControl.hasError('required')) {
        <div class="error-message ls-text-b3 font-medium" data-test-id="register-invite-code.error">{{ t('register.pleaseProvideValidInviteCode') }}</div>
      }
      <div class="pb-3">
        <label for="inviteCode" class="ml-entLbl">{{ t('register.inviteCode') }}</label>
      </div>
      <div>
        <input
          id="inviteCode"
          type="text"
          [formControl]="inviteCodeControl"
          class="max-w-full"
          [class.invalid]="inviteCodeControl.touched && inviteCodeControl.invalid"
          data-test-id="register-invite-code.input"
          [attr.aria-invalid]="inviteCodeControl.touched && inviteCodeControl.invalid"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="pt-5 pb-5">
      <ls-button
        btnType="submit"
        btnVariant="primary"
        size="lg"
        [upcase]="false"
        [label]="t('register.continue')"
        [disabled]="submitting()"
        data-test-id="register-invite-code.submit-button"
      ></ls-button>
    </div>
  </form>
  }
</ng-container>
